import React from 'react';
import {createBrowserRouter, RouterProvider} from 'react-router';
import {InterstateThemeProvider} from '@interstate/components/InterstateThemeProvider';
import {interstateThemeRegistry} from '@interstate/components/InterstateTheming/themes/interstateThemeRegistry';
import {AuthProvider, RequireAuth, RequireRole} from './context/AuthContext';
import Login from './pages/Login';
import NoAccess from './pages/NoAccess';
import Dashboard from './pages/Dashboard';
import Manage from './pages/Manage';
import {MOCK_ENABLED} from './dev/mock';
import RolePreviewSwitcher from './dev/RolePreviewSwitcher';

const router = createBrowserRouter([
  {path: '/', element: <Login />},
  {path: '/login', element: <Login />},
  {path: '/no-access', element: <NoAccess />},
  {
    path: '/dashboard',
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    )
  },
  {
    path: '/manage',
    element: (
      <RequireRole roles={['admin']}>
        <Manage />
      </RequireRole>
    )
  }
]);

export default function App(): React.ReactElement {
  return (
    <InterstateThemeProvider
      themeName="Interstate"
      themeRegistries={[interstateThemeRegistry]}
      applicationName="ETE AIT Leader Dashboard"
      scopeName="ait-tracker"
    >
      <AuthProvider>
        <RouterProvider router={router} />
        {/* Dev-only "view as" switcher. Folds to `false && …` in prod builds → tree-shaken out. */}
        {MOCK_ENABLED && <RolePreviewSwitcher />}
      </AuthProvider>
    </InterstateThemeProvider>
  );
}
